import React from "react";
import "./footer.scss";
function FooterComponent() {
  return (
    <>
      <footer>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h5>Products</h5>
            </div>
            <div className="col-md-3 col-6">
              <h6>Fitting Products</h6>
              {/* <ul>
                <li>
                  <a className="nav-link" href="/brasscomponents">
                    Brass Fittings
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    S.S Fittings
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Conduit Fittings
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="/pprinserts">
                    PPR Inserts
                  </a>
                </li>
              </ul> */}
            </div>
            <div className="col-md-3 col-6">
              <h6>Stamping Products</h6>
              {/* <ul>
                <li>
                  <a className="nav-link" href="#">
                    Wall Mounting Flanges
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Eletrical Contact Pins
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Brackets
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Clamps
                  </a>
                </li>
              </ul> */}
            </div>
            <div className="col-md-3 col-6">
              <h6>Machined Products</h6>
              {/* <ul>
                <li>
                  <a className="nav-link" href="#">
                    Mechanical Connectors
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Neutral Bars
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Forged Connectors
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Forged Clamps
                  </a>
                </li>
              </ul> */}
            </div>
            <div className="col-md-3 col-6">
              <h6>Plastic Products</h6>
              {/* <ul>
                <li>
                  <a className="nav-link" href="#">
                    Electrical Connectors
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Equipotential Bar
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#">
                    Rod Clamps &amp; Holders
                  </a>
                </li>
              </ul> */}
            </div>
            
            
          </div>
          <div className="row">
              <div className="col-md-12">
                <h5>Site Links</h5>
                <ul className="nav">
                  <li className="nav-item">
                    <a className="nav-link active" href="/home">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/about-us">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/industries-we-serve">
                      Industries We Serve
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      target="_blank"
                      href="/assets/img/AM – PM ENGINEERING CATALOG.pdf"
                    >
                      Catlogue
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/contact-us">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          <div className="row">
              <div className="col-3">
                <p> &copy; am-pm engineering 2020-21</p>
              </div>
            </div>
        </div>
      </footer>
    </>
  );
}

export default FooterComponent;
